import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSpotSwapPair } from '~/state/dex/hooks'
import { StyledDetailWrapper } from '~/components/Exchange/styled'
import { formatFormAmount } from '~/utils/numbers'
import Skeleton from '~/components/Exchange/components/Skeleton'
import { useIsSendByRelayer } from '~/components/Exchange/hooks'
import styled from 'styled-components'
import { formatUnits } from 'viem'

interface MinReceivedProps {
  amountOut: bigint
  fee: bigint
  loading: boolean
}

const ReceivedRow: React.FC<MinReceivedProps> = ({
  amountOut,
  fee,
  loading,
}) => {
  const { t } = useTranslation()
  const [, outputToken] = useSpotSwapPair()
  const isSendByRelayer = useIsSendByRelayer()

  const amount = useMemo(() => {
    // if (!amountOut || !fee) return '~'
    if (!amountOut) return '~'
    return formatFormAmount(
      formatUnits(BigInt(amountOut) - fee, outputToken.decimals),
    )
  }, [amountOut, fee])

  const labelLiteral = isSendByRelayer
    ? t('spotswap_received_row_relayer_label')
    : t('spotswap_received_row_self_label')

  return (
    <Container>
      <span>{labelLiteral}</span>
      {loading ? <Skeleton /> : <span>{amount}</span>}
    </Container>
  )
}

export default ReceivedRow

const Container = styled(StyledDetailWrapper)`
  font-size: 13px;
  font-weight: 700;
  line-height: 18.2px;
  color: ${({ theme }) => theme.colors.textBlack};
`
